<template src="./BotsList.template.html"></template>
<script>
  export default {
    name: "BotsList",
    props: [""],
    data() {
      return {
        headerColumnList: {

          BOTTYPE: {
            Label: "BOT TYPE",
            IsChecked: true,
            ColumnName: "BotType",
            isSortLoading: false,
            isAscOrDesc: null

          },
          BOTNAME: {
            Label: "BOT NAME",
            IsChecked: true,
            ColumnName: "BotName",
            isSortLoading: false,
            isAscOrDesc: null
          },

          ENTITY: { Label: "ENTITY", IsChecked: true, ColumnName: "Entity", isSortLoading: false, isAscOrDesc: null },
          EVENT: { Label: "EVENT", IsChecked: true, ColumnName: "Event", isSortLoading: false, isAscOrDesc: null },
          STATUS: { Label: "STATUS", IsChecked: true, ColumnName: "StatusId", isSortLoading: false, isAscOrDesc: null },
        },

        BotType: [{
          Name: "Messenger Bot",
          BotTypeId: 1
        },
        {
          Name: "Payment Bot",
          BotTypeId: 2
        }
        ],
        propertyList: [],
        statusList: [],
        BotsList: [],
        BotId: -99,
        statusId: 1,
        propertyId: -99,
        BotTypeId: -99,
        showlabel: false,
        botSearch:''

      };
    },
    methods: {
      splitJoin(id) { 
        if(id){
          return id.split(',');
        }
       
      },
       Searchtext(value) {
      let vm = this;
      console.log("valueeeeeeeeeee", value);
      vm.Get_BotsList();
    },
    clearbotSearch() {
      let vm = this;
      vm.botSearch = "";
      vm.Get_BotsList();
    },
      newBot() {

        let vm = this;

        // if (vm.BotId == 1) {
        //   vm.$router.push("/MessengerBotDetail/" + -1 + "/" + vm.BotId );
        // }
        // else if(vm.BotId == 2){

        //   vm.$router.push("/PaymentBotDetail/" + -1 + "/" + vm.BotId ); 

        // }

        vm.$router.push("/BotDetail/" + -1);

      },
      Get_BotsList() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_BotsList",
          params: {
            BotTypeId: vm.BotTypeId,
            PropertyId: vm.propertyId,
            StatusId: vm.statusId,
            SearchText:vm.botSearch
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("Get_BotsList===>", response);
              vm.BotsList = response.recordsets[0];
              if(vm.BotsList.length == 0){
                vm.showlabel = true;
              }
              else{
                vm.showlabel = false;
              }
              
            }
          }
        });
      },
      GetBotDetailById(BotId) {
        let vm = this;
        vm.$router.push("/BotDetail/" + BotId);
      },
      getPropertyMetaData: function () {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetPropertiesBySearchText",
          params: {},
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("GetPropertiesBySearchText==>", response);
              vm.propertyList.splice(0, vm.propertyList.length, ...response.propertyList);
              vm.statusList.splice(0, vm.statusList.length, ...response.statusList);

            }
          }
        });


      },



    },
    computed: {

    },
    mounted() {
      let vm = this;
      vm.Get_BotsList();
      vm.getPropertyMetaData();
    },

  };
</script>